import { useEffect, useState } from 'react';
import './App.css';
import HomePage from './Pages/HomePage';
import arrowIcon from "./Assets/Icons/arrow.png";

function App() {
  const [showButton, setShowButton] = useState(false);


  // const handleClick = () => {
  //   const phoneNumber = '+27676545748';
  //   const url = `https://wa.me/${phoneNumber}`;
  //   window.open(url, '_blank');
  // };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleScroll = () => {
    if (window.pageYOffset > 20) {
      setShowButton(true);
    } else {
      setShowButton(false);
    }
  };
  return (
    <>
      <HomePage />
      
      {showButton && (
        <>
        <div className='hidden-btn'>
          <button className='upBtn'
            onClick={() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }}
            title='Scroll up'
          > <img className='arrowBtn' src={arrowIcon} alt='arrowIcon' />
          </button>
        </div>
        {/* <button className='whatsapp' onClick={handleClick}><img className='whatsappIcn' src={waIcon} alt='whatsapp' /></button> */}
        </>
      )}

    </>
  );
}

export default App;
